import * as React from "react";
import { forwardRef } from "react";
const SvgColorStatusSActive = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { opacity: 0.5, x: 4.5, y: 4.5, width: 15, height: 15, stroke: "currentColor", strokeWidth: 3, strokeLinejoin: "bevel" }), /* @__PURE__ */ React.createElement("rect", { x: 6, y: 6, width: 12, height: 12, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgColorStatusSActive);
export { ForwardRef as ReactComponent };
